import { useResetAtom } from 'jotai/utils'
import React from 'react'

import { useInvalidateCommonQuery } from '~/hooks/useCommonQuery'
import { useInvalidateCurrentBrandAccountSurveyGroupsQuery } from '~/hooks/useCurrentBrandAccountSurveyGroupsQuery'

import { dialogInfoAtom } from '../atoms'
import { useInvalidateMainQuery } from '../hooks/useMainQuery'

export const useCloseDialogWithRefresh = () => {
  const invalidateCommonQuery = useInvalidateCommonQuery()
  const resetDialogInfo = useResetAtom(dialogInfoAtom)

  const invalidateMainQuery = useInvalidateMainQuery()
  const invalidateCurrentBrandAccountSurveyGroupsQuery =
    useInvalidateCurrentBrandAccountSurveyGroupsQuery()

  return React.useCallback(async () => {
    await Promise.all([
      invalidateCommonQuery(),
      invalidateMainQuery(),
      invalidateCurrentBrandAccountSurveyGroupsQuery(),
    ])
    resetDialogInfo()
  }, [
    invalidateCommonQuery,
    invalidateMainQuery,
    resetDialogInfo,
    invalidateCurrentBrandAccountSurveyGroupsQuery,
  ])
}
